// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"e46efa54","4289":"e46efa54","5534":"ee384ee1","9664":"e46efa54"}[chunkId] + ".chunk.css";
};